import styled from "styled-components";

export const CSRF = styled("input").attrs(() => ({
	type: "hidden",
}))``;
